import { Fetcher } from '@this/src/util';
import type { HotelProposalReasonsResult, HotelProposalReasonStatus } from '../types/hotelProposalReasons';

type HotelProposalReasonResponse = {
  item_id: number;
  reason: string;
};

type HotelProposalReasonsResponse = {
  bundle_id: number;
  status: HotelProposalReasonStatus;
  summary_reason: string | null;
  item_reasons: HotelProposalReasonResponse[];
};

const mapHotelProposalReasonsResponse = (response: HotelProposalReasonsResponse): HotelProposalReasonsResult => ({
  bundleId: response.bundle_id,
  status: response.status,
  summaryReason: response.summary_reason,
  itemReasons: response.item_reasons.map(entry => ({
    itemId: entry.item_id,
    reason: entry.reason
  }))
});

export const fetchHotelProposalReasons = async (
  tripId: string,
  bundleId: number
): Promise<HotelProposalReasonsResult> => {
  const response = await Fetcher.get<HotelProposalReasonsResponse>(
    `/trips/${tripId}/ai_proposal_bundles/${bundleId}/hotel_reasons.json`
  );
  return mapHotelProposalReasonsResponse(response);
};
